import { Moment } from 'moment';

export interface emailObjType {
    companyName: string,
    companyLogo: string,
    headerAfterName: string,
    description: string,
    installmentOption: number,
    ifFreePeriod: boolean,
    freePeriod: number,
    refLink: string,
    salaryAdvanceService: string,
    paymentService: string,
    internalTransferringService: string,
    shoppingService: string,
    payrollDescription: string,
    serviceFees: number,
    howItWorks1: string,
    howItWorks2: string,
    howItWorks3: string,
    howItWorks4: string,
    videoLink: string,
    questionsContact: string,
    questionsString: string,
}

export interface companyInfo {
    name: string,
    companyName: string,
    id: number,
    description: string,
    logoID: string,
    salaryCycleStartDay: string,
    salaryCycleEndDay: string,
    arabicName: string,
    arabicDescription: string,
    balanceCap?: number,
    maxInstallmentCount: string,
    salaryPreparationDay: string,

    maxAdvancePercentAllowed: number,
    fees: number,
    shoppingBalancePercentage: number,

    createdAt: string,
    staff_id: string,
    maxShoppingInstallmentsCount: number,
    deployed: any,
    companyType: string | null,
    companyIndustry: string | null,
    cashEnabled: number | null,
    requestRequiresActiveUser: number | null,
    staffIDRequired: number | null,
    consentRequired: number | null,
    hrLetterRequired: number | null,
    nationalIDRequired: number | null,
    promissoryNoteRequired: number | null,
    requestRequiredHRApproval: number | null,
    nationalIDRequiredByCompany: number | null,
    staffIDRequiredByCompany: number | null,
    hasDeductionBasedFreePeriods: number | null,
    estimatedNumbersOfUsers: number,
    collectionDayExact: number,
    userFreePaymentCycles: number,
    companyFreeMonths: number,
    maxMonthlyPercentAllowed: number,
    SPOCs: [],
    availableForDeployment: number,
    communicationCycles: [],
    defaultInactiveNextStatus: string,
    defaultSignupStatus: string,
    maxMonthlyRequestsLimitPerUser: number,
    establishedAt: string,
    departments: [],
    deploymentDate?: string,
    freePeriodExpiryDate?: string,
    address?: string,
    taxIdentificationNumber?: string,
    registrationNumber?: string,
    probationPeriod: number,
    legalName?: string,
    crNumber?: string,
    unifiedNumber?: string,
    crIssueDate?: string,
    crIssuePlace?: string,
    nationalAddress?: string,
    contactInformation?: string,
}
export interface userInfo {
    name: string,
    companyName: string,
    phone: string,
    email: string,

    consent: [],
    nationalId: any,
    hrLetter: [],
    accountCreatedAt: string,
    bankAccountHolderName: string,
    bankAccountNumber: string,
    bankName: string,

    userStatus: string,
    userStatusType: string,

    maxAdvancePercentAllowedPerCompany: number,
    maxBalance: number,
    maxShoppingBalnce: number,

    wallet: number,
    staff_id: string,
    companyMaxInstallmentCount: number,
    nationalIDNumber: string,
    netSalary: any,
    maxMonthlyRequestsLimit: any,
}
export interface resolveIssues {
    actionsReducer: any;
}
export interface transactionInterface {
    transaction: {
        company: string,
        totalAmount: string,
        name: string,
        transactionID: number,
        referenceNumber: number,
        createdAt: string,
        serviceOne: string,
        serviceTwo: string,
        serviceThree: string,
        serviceFour: string,
        companyRef: string,
        logoURL: string,
        actionBy: {
            firstName: string,
            lastName: string,
            middleName: string,
        },
        transactionsBreakdown: any[],
        userID: {
            staffID: string,
            nationalID: string,
            company: {
                logoURL: string
            }
        },
    }
}

export interface ITableCol {
    [x: string]: any;
    title: string;
    dataIndex: string;
    render?: (value: string) => JSX.Element;

}
export interface IUserAccounts {
    userID: string,
    phoneNumber: string,
    staffID: string,
    userName: string,
    companyName: string,
    userStatus: string,
}
export enum CallCenterModules {
    willPay = 17
}

export interface EditCompanyFeesProps {
    isDeployedCompany?: boolean
}
export interface ITableColumn {
    title: string;
    dataIndex: string;
    key: string;
}
export interface ITable {
    data: any[];
    columns: ITableColumn[];
    loading: boolean;
    currentPage?: number;
    total?: number;
    perPage?: number;
}

export interface ISettlementFormValues {
    discount: number
    submitEarlySettlementDate: string
}

export interface IStateInfo {
    userDues: number
    futureFees: number
    advancePayments: number
    userID: string
    earlySettlementDiscountOnFutureFees: number
    earlySettlementDiscount: number,
    futureRevenueEligibleForDiscount: number,
    selectedCycle: {
        companyID: number,
        paymentCycle: number,
        pc: string,
        collectionDueDate: string
    },
}
export interface IAddCollections {
    isCompany: boolean,
    identifier: any
}
export interface ICompany {
    [key: string]: {
        info?: companyInfo,
    }
}
export interface IUserInfo {
    userID: string,
    name: string,
    phone: string,
    companyName?: string
    companyID?: number,
}

export interface IAddCollectionsPayload {
    companyID?: Number,
    phone?: string,
    amount: string,
    collectionDate: string,
    referenceNumber: string,
    paymentCycle?: number,
    startEarly?: boolean,
}

export enum CollectionAmountType {
    manual = "1",
    uploadSheet = "2",
}

export interface IInvoicesAmount {
    totalRemainingUnassignedCollection: number,
    totalInvoiceAmount: number,
    totalRemainingInvoiceAmount: number,
}

export interface IRequestEarlySettlement {
    earlySettlementDate: string
}

export interface IUnidentifiedCollection {
    companyID?: number,
    phone?: string,
}

export enum MeezaCardStatus {
    notRecieved,
    requested,
    recievied
}

export interface ICompanyDropDown {
    id: number;
    name: string;
    maxInstallmentCount?: string | number;
}

export interface IService {
    id: number;
    name: string;
}

export interface ICompanyResponse {
    status: number;
    data: ICompanyDropDown[];
    message?: string;
}

export interface IServiceResponse {
    status: number;
    data: {
        data: {
            servicesGroups: IService[];
        };
    };
    message?: string;
}

export interface IOfferFormData {
    companyID: number | null;
    startDate: Moment | null;
    endDate: Moment | null;
    discountPercentage: string | number | null;
    activateUponFirstRequest: boolean;
    maxAllowedRequests?: number | null;
    maxAllowedAmount?: string | number | null;
    services: number[];
    freeMonths?: number | null;
    companyMaxInstallments?: number | null;
    minInstallments?: number | null;
}

export interface IFormState {
    loading: boolean;
    loadingData: boolean;
    companies: ICompanyDropDown[];
    services: IService[];
    errorMode: boolean;
    errorMessage: string | null;
}

export interface IApiResponse<T = any> {
    status: number;
    data: T;
    message?: string;
    error?: boolean;
}

export enum InvoiceType {
    B2B_INVOICE = 1,
    B2B_CREDIT_NOTE = 2,
    B2C_INVOICE = 3,
}

export interface TaxableInvoicesFilters {
    invoiceType?: InvoiceType;
    invoiceNumber?: string;
    userID?: string | number;
    companyID?: string | number;
    startDate?: string;
    endDate?: string;
}
export interface IUser {
    userID?: string;
    staff_id: string;
    name: string;
    phone: string;
    outstandingAmount: number;
    remainingInstallments: number;
    status: string;
    activeRequests?: number;
    activeRequestsAmount?: number;
    totalRequestedAmount?: number;
    withWithoutFees?: string;
    suspensionReason?: string;
    suspensionDate?: string;
    isSuspended?: boolean;
}

export interface ISummary {
    transactingUsersCount: number;
    totalOutstandingAmount: number;
}
export interface IFilters {
    staffID?: string | null;
    phoneNumber?: string | null;
    statusID?: string | null;
    nationalID?: string | null;
}
/**
 * Semantic Versioning (SemVer) Types:
 * 
 * MAJOR (x.0.0): Breaking changes - Changes that break backward compatibility
 *   - API changes that require code updates
 *   - Major architectural changes
 *   - Removing features
 * 
 * MINOR (x.y.0): New features - Backward compatible additions
 *   - feature: New functionality added
 *   - improvement: Enhancements to existing features
 * 
 * PATCH (x.y.z): Bug fixes - Backward compatible bug fixes
 *   - fix: Bug fixes and error corrections
 *   - security: Security patches and vulnerability fixes
 */
export interface IReleaseNote {
    version: string; // Format: v1.9.17 (MAJOR.MINOR.PATCH)
    date: string;
    notes: string[];
    type: 'feature' | 'fix' | 'security' | 'improvement';
    versionType: 'MAJOR' | 'MINOR' | 'PATCH'; // Semantic versioning type
}

export interface IUsersSummary {
    salaryAdvancesPrincipal?: number | null;
    salaryAdvancesFees?: number | null;
    salaryAdvancesVAT?: number | null;
    previousDues?: number | null;
    earlySettlementAmounts?: number | null;
    totalDueCollection?: number | null;
    totalDueUsers?: number | null;
    totalRewardsApplied?: number | null;
}

export interface IInstallmentTotal {
    totalDueActiveUsers?: number | null;
    totalDueResignedUsers?: number | null;
    totalDueThisMonth?: number | null;
    companyName?: string | null;
    nationalAddress?: string | null;
    taxIdentificationNumber?: string | null;
    cutoffCycleDate?: string | null;
    serialNumber?: string | null;
    activeUsersSummary?: IUsersSummary | null;
    resignedUsersSummary?: IUsersSummary | null;
    sellerTaxIdentificationNumber?: string | null;
}

export interface IInvoiceData {
    salariesPaid?: string | null;
    fees?: number | null;
    subject?: string | null;
    com?: string | null;
    date?: string | null;
    serial?: string | null;
    settled?: string | null;
    total?: string | null;
    taxRate?: number | null;
    taxFees?: number | null;
    debitAndCredit?: number | null;
    discount?: number | null;
    previousCreditRevenue?: number | null;
    userType?: 'Active' | 'Resigned' | null;
    isResigned?: boolean | null;
    totalDueThisMonth?: number | null;
    taxIdentificationNumber?: string | null;
    nationalAddress?: string | null;
    installmentTotal?: IInstallmentTotal | null;
    sellerTaxIdentificationNumber?: string | null;
}

export interface IAddRewardsFormValues {
    rewardsAmount: number;
    sendSms: boolean;
}